import React, { useCallback, useEffect, useRef, useState } from "react";
import "./index.scss";
import storage from "utils/data/storage";
import { buildFileURL } from "utils/data";
import { EVENT_KEY, EventEmitter } from "utils/eventManager";
import { concat, isEmpty, isEqual } from "lodash";
import cx from "classnames";
import player from "utils/player";
import { useCurrentIndex } from "components/utils/hooks";

const TAB_ON = "tab_on";
const TAB_OFF = "tab_off";

const buildSources = (file) => {
  return {
    src: buildFileURL(`video/${file?.filename}.mp4`),
    type: "audio/mp4",
    timestamp: file?.timestamp,
  };
};

const VideoWebcams = ({ sticker = {} }) => {
  const events = storage?.data?.events || {};
  const { webcamStudents = {}, webcamTeacher = {} } = events;
  const currentIndexMessage = useCurrentIndex(storage.messages);

  const videoRef = useRef({});
  const videoPlayingRef = useRef([]);
  const [videoPlaying, setVideoPlaying] = useState([]);
  const [videoWebcamTeacher, setVideoWebcamTeacher] = useState({});
  const [videoWebcamStudents, setVideoWebcamStudents] = useState({});
  const [isFakeVideoWebcam, setIsFakeVideoWebcam] = useState(false);

  const videoTeacherPlaying = () => {
    const _keys = Object.keys(videoWebcamTeacher);
    return videoPlaying.filter((item) =>
      _keys.some((_key) => item.includes(_key))
    );
  };
  const numberVideoTeacherPlaying = videoTeacherPlaying()?.length || 0;
  const numberVideoStudentPlaying =
    videoPlaying?.length - numberVideoTeacherPlaying || 0;

  // const studentsHasWebcam = Object.keys(videoWebcamStudents || {})?.filter(
  //   (_videoItem) => {
  //     return !isEmpty(videoWebcamStudents[_videoItem]);
  //   }
  // );
  // const numberWebcams = studentsHasWebcam?.length || 0;

  const checkVideoPlaying = useCallback(
    (timeVideo) => {
      const mergedVideos = {
        ...videoWebcamStudents,
        ...videoWebcamTeacher,
      };
      let _videoPlaying = {};
      for (const key in mergedVideos) {
        if (mergedVideos.hasOwnProperty(key)) {
          const index = mergedVideos[key]?.findLastIndex((video, index) => {
            return (
              !!videoRef.current?.[`${key}/${index}`]?.current?.duration &&
              timeVideo >= video?.timestamp &&
              timeVideo <=
                video?.timestamp +
                  videoRef.current?.[`${key}/${index}`]?.current?.duration
            );
          });

          if (index >= 0) {
            _videoPlaying = { ..._videoPlaying, [key]: index };
          }
        }
      }
      // for (const key in videoWebcamStudents) {
      //   if (videoWebcamStudents.hasOwnProperty(key)) {
      //     const index = videoWebcamStudents[key]?.findLastIndex(
      //       (video, index) => {
      //         return (
      //           !!videoRef.current?.[`${key}/${index}`]?.current?.duration &&
      //           timeVideo >= video?.timestamp &&
      //           timeVideo <=
      //             video?.timestamp +
      //               videoRef.current?.[`${key}/${index}`]?.current?.duration
      //         );
      //       }
      //     );

      //     if (index >= 0) {
      //       _videoPlaying = { ..._videoPlaying, [key]: index };
      //     }
      //   }
      // }

      // for (const key in videoWebcamTeacher) {
      //   if (videoWebcamTeacher.hasOwnProperty(key)) {
      //     const index = videoWebcamTeacher[key]?.findLastIndex(
      //       (video, index) => {
      //         return (
      //           !!videoRef.current?.[`${key}/${index}`]?.current?.duration &&
      //           timeVideo >= video?.timestamp &&
      //           timeVideo <=
      //             video?.timestamp +
      //               videoRef.current?.[`${key}/${index}`]?.current?.duration
      //         );
      //       }
      //     );
      //     if (index >= 0) {
      //       _videoPlaying = { ..._videoPlaying, [key]: index };
      //     }
      //   }
      // }

      return _videoPlaying;
    },
    [videoWebcamStudents, videoWebcamTeacher]
  );

  // Kiểm tra tab có được focus không
  // Nếu từ tab khác quay lại thì sẽ set lại thời gian hiện tại của video
  // và cập nhật danh sách video đang phát
  useEffect(() => {
    const _video = { ...videoWebcamTeacher, ...videoWebcamStudents };
    if (isEmpty(_video)) return;
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        const _isPaused = player.webcams.paused();
        if (!_isPaused) {
          const currentTime = player.webcams.currentTime();
          const _videoPlaying = checkVideoPlaying(currentTime);
          const _listVideoPlaying = Object.entries(_videoPlaying).map(
            ([key, index]) => {
              const keyRef = `${key}/${index}`;
              const videoEl = videoRef.current?.[keyRef]?.current;
              if (videoEl) {
                videoEl.currentTime =
                  currentTime - (_video?.[key]?.[index]?.timestamp || 0);
              }
              return keyRef;
            }
          );
          Object.keys(videoRef.current).forEach((keyRef) => {
            if (!_listVideoPlaying.includes(keyRef)) {
              const videoEl = videoRef.current?.[keyRef]?.current;
              if (videoEl) videoEl.currentTime = 0;
            }
          });
          setVideoPlaying(_listVideoPlaying);
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [checkVideoPlaying, videoWebcamStudents, videoWebcamTeacher]);

  // Xử lý video webcam teacher
  useEffect(() => {
    if (!webcamTeacher) return;

    const newVideoWebcamTeacher = {};

    for (const key in webcamTeacher) {
      if (Object.prototype.hasOwnProperty.call(webcamTeacher, key)) {
        newVideoWebcamTeacher[key] = webcamTeacher[key]?.map((item) =>
          buildSources(item)
        );
      }
    }

    setVideoWebcamTeacher(newVideoWebcamTeacher);
  }, [webcamTeacher]);

  // Xử lý video webcam students
  useEffect(() => {
    if (!webcamStudents) return;

    const newVideoWebcamStudents = {};

    for (const key in webcamStudents) {
      if (webcamStudents.hasOwnProperty(key)) {
        newVideoWebcamStudents[key] = webcamStudents[key]?.map((item) =>
          buildSources(item)
        );
      }
    }

    setVideoWebcamStudents(newVideoWebcamStudents);
  }, [webcamStudents]);

  // Xử lý video webcamps theo video src
  useEffect(() => {
    const _video = { ...videoWebcamTeacher, ...videoWebcamStudents };
    if (isEmpty(_video)) return;

    // Đặt thời gian hiện tại cho video và thêm vào danh sách video đang phát
    for (const key in _video) {
      if (_video.hasOwnProperty(key)) {
        _video[key]?.forEach((item, index) => {
          if (item?.timestamp <= 0) {
            const keyRef = `${key}/${index}`;
            const videoEl = videoRef.current?.[keyRef]?.current;
            if (videoEl) {
              videoEl.currentTime = -item.timestamp;
              setVideoPlaying((prev) =>
                prev.includes(keyRef) ? prev : concat(prev, keyRef)
              );
            }
          }
        });
      }
    }

    // Handle time update
    EventEmitter.subscribe(EVENT_KEY.TIME_UPDATE_WEBCAMS, (timeVideo) => {
      const _videoPlaying = checkVideoPlaying(timeVideo + 1);
      const _listVideoPlaying = Object.keys(_videoPlaying).map(
        (key) => `${key}/${_videoPlaying[key]}`
      );
      if (isEqual(_listVideoPlaying, videoPlayingRef.current)) return;
      videoPlayingRef.current = _listVideoPlaying;
      setVideoPlaying(_listVideoPlaying);
      const _videoRef = videoRef.current;

      // Sync play/pause for each video
      for (const keyRef in _videoRef) {
        const videoEl = _videoRef[keyRef]?.current;
        if (!videoEl) continue;

        // Kiểm tra xem video có trong danh sách video đang phát hay không
        const shouldPlay = _listVideoPlaying.includes(keyRef);
        // Chạy video nếu nó nằm trong danh sách video đang phát và đang dừng
        if (shouldPlay && videoEl.paused) {
          const [key, index] = keyRef.split("/") || [];
          const timestamp = _video?.[key]?.[index]?.timestamp;
          const currentTime = timeVideo - timestamp;

          if (
            (videoEl.currentTime > currentTime + 0.5 ||
              videoEl.currentTime < currentTime - 0.5) &&
            !!key
          ) {
            videoEl.currentTime = currentTime;
          }

          videoEl.play();
        } else if (!shouldPlay && !videoEl.paused) {
          videoEl.pause();
        }
      }
    });

    // Handle pasue video (Pause all videos)
    EventEmitter.subscribe(EVENT_KEY.PAUSE_WEBCAMS, () => {
      Object.entries(_video).forEach(([key, videoList]) => {
        videoList?.forEach((_, index) => {
          videoRef.current?.[`${key}/${index}`]?.current?.pause();
        });
      });
      videoPlayingRef.current = [];
    });

    // Handle pasue video (Pause all videos)
    EventEmitter.subscribe(EVENT_KEY.PLAYBACK_RATE_WEBCAMS, (playbackRate) => {
      Object.entries(_video).forEach(([key, videoList]) => {
        videoList?.forEach((_, index) => {
          const video = videoRef.current?.[`${key}/${index}`]?.current;
          if (video) {
            video.playbackRate = playbackRate;
          }
        });
      });
    });

    // Handle seek event
    EventEmitter.subscribe(EVENT_KEY.TIME_SEEK_WEBCAMS, (timeVideo) => {
      const _videoPlaying = checkVideoPlaying(timeVideo);
      const _listVideoPlaying = Object.entries(_videoPlaying).map(
        ([key, index]) => {
          const keyRef = `${key}/${index}`;
          const videoEl = videoRef.current?.[keyRef]?.current;
          if (videoEl) {
            videoEl.currentTime =
              timeVideo - (_video?.[key]?.[index]?.timestamp || 0);
          }
          return keyRef;
        }
      );

      Object.keys(videoRef.current).forEach((keyRef) => {
        if (!_listVideoPlaying.includes(keyRef)) {
          const videoEl = videoRef.current?.[keyRef]?.current;
          if (videoEl) videoEl.currentTime = 0;
        }
      });

      setVideoPlaying(_listVideoPlaying);
    });

    // Cleanup
    return () => {
      EventEmitter.unsubscribe(EVENT_KEY.TIME_UPDATE_WEBCAMS);
      EventEmitter.unsubscribe(EVENT_KEY.PAUSE_WEBCAMS);
      EventEmitter.unsubscribe(EVENT_KEY.TIME_SEEK_WEBCAMS);
      videoPlayingRef.current = [];
      setVideoPlaying([]);
    };
  }, [checkVideoPlaying, videoWebcamStudents, videoWebcamTeacher]);

  useEffect(() => {
    if (isEmpty(storage.messages)) return setIsFakeVideoWebcam(false);

    const listMessage = storage.messages?.findLastIndex((item, index) => {
      return (
        index <= currentIndexMessage &&
        [TAB_OFF, TAB_ON].some((word) => item?.message?.includes(word))
      );
    });

    if (listMessage < 0) return setIsFakeVideoWebcam(false);

    const activeMessage = storage.messages[listMessage] || {};
    const isTabOff = activeMessage?.message?.includes(TAB_OFF);
    setIsFakeVideoWebcam(isTabOff);
  }, [currentIndexMessage]);

  return (
    <div className="video-webcams">
      <div
        className={cx({
          "video-webcams__teacher": true,
          "grid-1": numberVideoTeacherPlaying === 1,
          "grid-2":
            numberVideoTeacherPlaying >= 2 && numberVideoTeacherPlaying <= 4,
          "grid-3": numberVideoTeacherPlaying > 4,
        })}
      >
        {Object.keys(videoWebcamTeacher).map((key) => {
          if (isEmpty(videoWebcamTeacher[key])) return null;
          const _isActiveTeacher = videoWebcamTeacher[key].some((_, i) =>
            videoPlaying.includes(`${key}/${i}`)
          );

          return (
            <div
              className={cx({
                "video-webcams__teacher-item": true,
                "video-webcams__students-item--unactive": !_isActiveTeacher,
              })}
              key={key}
            >
              {videoWebcamTeacher[key]?.map((item, index) => {
                const videoKey = `${key}/${index}`;
                videoRef.current = {
                  ...videoRef.current,
                  [`${videoKey}`]: React.createRef(),
                };
                const active = videoPlaying.includes(videoKey);

                return (
                  <>
                    <video
                      className={`video-webcam-js ${
                        active ? "video-webcam-js--active" : ""
                      }`}
                      key={videoKey}
                      playsInline
                      preload="auto"
                      src={item.src}
                      ref={videoRef.current?.[`${videoKey}`]}
                      muted
                      // onDurationChange={(e) => {
                      //   const duration = e.target.duration;
                      //   setDuration((prev) => ({ ...prev, [videoKey]: duration }));
                      // }}
                    />
                    {isFakeVideoWebcam && (
                      <div className="video-webcam-fake">
                        <img
                          className="video-webcam-fake__img"
                          src={require(`assets/images/logo-kyna.png`)}
                          alt="img"
                        />
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          );
        })}
      </div>
      <div
        className={cx({
          "video-webcams__students": true,
          // "grid-1": numberWebcams === 1,
          // "grid-2": numberWebcams >= 2 && numberWebcams <= 4,
          // "grid-3": numberWebcams > 4,
          "grid-1": numberVideoStudentPlaying === 1,
          "grid-2":
            numberVideoStudentPlaying >= 2 && numberVideoStudentPlaying <= 4,
          "grid-3": numberVideoStudentPlaying > 4,
        })}
      >
        {Object.keys(videoWebcamStudents).map((key) => {
          if (isEmpty(videoWebcamStudents[key])) return null;
          const _isActiveStudent = videoWebcamStudents[key].some((_, i) =>
            videoPlaying.includes(`${key}/${i}`)
          );
          // let isOneActive = false;
          // for (let i = 0; i < videoWebcamStudents[key].length; i++) {
          //   if (videoPlaying.includes(`${key}/${i}`)) {
          //     isOneActive = true;
          //     break;
          //   }
          // }

          return (
            <div
              className={cx({
                "video-webcams__students-item": true,
                "video-webcams__students-item--unactive": !_isActiveStudent,
              })}
              key={key}
            >
              {videoWebcamStudents[key]?.map((item, index) => {
                const videoKey = `${key}/${index}`;
                videoRef.current = {
                  ...videoRef.current,
                  [`${videoKey}`]: React.createRef(),
                };
                const active = videoPlaying.includes(videoKey);

                return (
                  <video
                    key={videoKey}
                    className={`video-webcam-js ${
                      active ? "video-webcam-js--active" : ""
                    }`}
                    playsInline
                    preload="auto"
                    src={item.src}
                    ref={videoRef.current?.[`${videoKey}`]}
                    muted
                    // onDurationChange={(e) => {
                    //   const duration = e.target.duration;
                    //   setDuration((prev) => ({ ...prev, [videoKey]: duration }));
                    // }}
                  />
                );
              })}

              {sticker?.[key]?.count > 0 && (
                <div className="video-webcams__sticker">
                  <img
                    className="video-webcams__sticker__icon"
                    src={require(`assets/images/stickers/${sticker?.[key]?.stickerImg}.png`)}
                    alt="sticker"
                  />
                  <div className="video-webcams__sticker__count">
                    {sticker?.[key]?.count}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VideoWebcams;
